var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _reverseInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/reverse");

var _bindInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/bind");

var _concatInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/concat");

var _keysInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/keys");

var _sliceInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/slice");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/core-js/parse-int", "@babel/runtime-corejs3/helpers/possibleConstructorReturn", "@babel/runtime-corejs3/helpers/getPrototypeOf", "@babel/runtime-corejs3/helpers/get", "@babel/runtime-corejs3/helpers/inherits", "@babel/runtime-corejs3/core-js/set-timeout", "@babel/runtime-corejs3/core-js/json/stringify", "@babel/runtime-corejs3/core-js/date/now", "@babel/runtime-corejs3/regenerator", "@babel/runtime-corejs3/core-js/instance/slice", "@babel/runtime-corejs3/core-js/object/keys", "@babel/runtime-corejs3/core-js/instance/concat", "@babel/runtime-corejs3/core-js/get-iterator", "@babel/runtime-corejs3/helpers/asyncToGenerator", "@babel/runtime-corejs3/core-js/instance/bind", "@babel/runtime-corejs3/helpers/objectSpread", "@babel/runtime-corejs3/core-js/object/create", "@babel/runtime-corejs3/helpers/classCallCheck", "@babel/runtime-corejs3/helpers/createClass", "@babel/runtime-corejs3/core-js/object/assign", "../package.json", "./js-tracker", "./promise", "./timeonpage", "./performance", "./api-tracker", "./api-tracker/xhr", "@ke/tenet/reverse", "@ke/tenet/report", "blueimp-md5", "./flow", "./utils", "./constant"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/core-js/parse-int"), require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs3/helpers/getPrototypeOf"), require("@babel/runtime-corejs3/helpers/get"), require("@babel/runtime-corejs3/helpers/inherits"), require("@babel/runtime-corejs3/core-js/set-timeout"), require("@babel/runtime-corejs3/core-js/json/stringify"), require("@babel/runtime-corejs3/core-js/date/now"), require("@babel/runtime-corejs3/regenerator"), require("@babel/runtime-corejs3/core-js/instance/slice"), require("@babel/runtime-corejs3/core-js/object/keys"), require("@babel/runtime-corejs3/core-js/instance/concat"), require("@babel/runtime-corejs3/core-js/get-iterator"), require("@babel/runtime-corejs3/helpers/asyncToGenerator"), require("@babel/runtime-corejs3/core-js/instance/bind"), require("@babel/runtime-corejs3/helpers/objectSpread"), require("@babel/runtime-corejs3/core-js/object/create"), require("@babel/runtime-corejs3/helpers/classCallCheck"), require("@babel/runtime-corejs3/helpers/createClass"), require("@babel/runtime-corejs3/core-js/object/assign"), require("../package.json"), require("./js-tracker"), require("./promise"), require("./timeonpage"), require("./performance"), require("./api-tracker"), require("./api-tracker/xhr"), require("@ke/tenet/reverse"), require("@ke/tenet/report"), require("blueimp-md5"), require("./flow"), require("./utils"), require("./constant"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.parseInt, global.possibleConstructorReturn, global.getPrototypeOf, global.get, global.inherits, global.setTimeout, global.stringify, global.now, global.regenerator, _sliceInstanceProperty2(global), _keysInstanceProperty(global), _concatInstanceProperty2(global), global.getIterator, global.asyncToGenerator, _bindInstanceProperty2(global), global.objectSpread, global.create, global.classCallCheck, global.createClass, global.assign, global._package, global.jsTracker, global.promise, global.timeonpage, global.performance, global.apiTracker, global.xhr, _reverseInstanceProperty(global), global.report, global.blueimpMd5, global.flow, global.utils, global.constant);
    global.index = mod.exports;
  }
})(this, function (_exports, _parseInt2, _possibleConstructorReturn2, _getPrototypeOf2, _get3, _inherits2, _setTimeout2, _stringify, _now, _regenerator, _slice, _keys, _concat, _getIterator2, _asyncToGenerator2, _bind, _objectSpread2, _create, _classCallCheck2, _createClass2, _assign, _package, _jsTracker, _promise, _timeonpage, _performance, _apiTracker, _xhr, _reverse, _report2, _blueimpMd, _flow, _utils, _constant) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.Ilog = _exports.Plog = _exports.Elog = void 0;
  _parseInt2 = _interopRequireDefault(_parseInt2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _get3 = _interopRequireDefault(_get3);
  _inherits2 = _interopRequireDefault(_inherits2);
  _setTimeout2 = _interopRequireDefault(_setTimeout2);
  _stringify = _interopRequireDefault(_stringify);
  _now = _interopRequireDefault(_now);
  _regenerator = _interopRequireDefault(_regenerator);
  _slice = _interopRequireDefault(_slice);
  _keys = _interopRequireDefault(_keys);
  _concat = _interopRequireDefault(_concat);
  _getIterator2 = _interopRequireDefault(_getIterator2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _bind = _interopRequireDefault(_bind);
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _create = _interopRequireDefault(_create);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assign = _interopRequireDefault(_assign);
  _package = _interopRequireDefault(_package);
  _jsTracker = _interopRequireDefault(_jsTracker);
  _promise = _interopRequireDefault(_promise);
  _timeonpage = _interopRequireDefault(_timeonpage);
  _performance = _interopRequireDefault(_performance);
  _apiTracker = _interopRequireDefault(_apiTracker);
  _reverse = _interopRequireDefault(_reverse);
  _report2 = _interopRequireDefault(_report2);
  _blueimpMd = _interopRequireDefault(_blueimpMd);
  _flow = _interopRequireDefault(_flow);

  var _context15, _context16, _context17;

  var commonConfig = (0, _assign.default)({}, _constant.DEFAULT_CONFIG);
  var global = typeof window !== 'undefined' ? window : typeof void 0 !== 'undefined' ? void 0 : {}; // class BehaviorQueue extends Queue {
  //   constructor (maxSize) {
  //     super()
  //     this.maxSize = maxSize
  //   }
  //   // 事件入队，用于记录错误发生时用户的行为路径
  //   enqueue (record = {}) {
  //     let leagle = record && Object.values(BEHAVIOR_TYPES_MAP).includes(record.type)
  //     if (!leagle) return
  //     // 如果队列已满，则出队后再入队
  //     if (this.size === this.maxSize) {
  //       this.dequeue()
  //     }
  //     this.data.push(record)
  //   }
  //   enqueueWithCheck (event) {
  //     const allowType = BEHAVIOR_TYPES_MAP.BEHAVIOR_TYPES_API
  //     const queue = this.data
  //     const size = this.size
  //     let apiRecords = queue.filter(record => record.type === allowType)
  //     let apiCount = apiRecords.length
  //     // 若超出，则距离当前时间最久的 api 日志出队
  //     if ((apiCount / size) >= (1 / 3)) {
  //       let index = queue.findIndex(record => record.type === allowType)
  //       this.deleteOne(index)
  //     }
  //     this.enqueue(event)
  //   }
  // }

  var Base =
  /*#__PURE__*/
  function () {
    function Base() {
      (0, _classCallCheck2.default)(this, Base);
      // 是否为测试模式
      this.isTest = true; // 是否为覆盖模式

      this.isOverwrite = false; // 是否监控JS错误

      this.needRecordJsError = true; // 是否监控用户在线时长

      this.needRecordTimeOnPage = true; // 是否监控性能指标

      this.needRecordPerformance = true; // 是否监控接口请求

      this.needRecordInterface = true; // 是否记录用户操作

      this.needRecordOperation = false; // 初始化配置

      this.config = (0, _create.default)(null); // 事件队列，用于还原发生错误时的用户行为
      // this.behaviorQueue = null

      this.upload = _xhr.upload; // 初始化tenet

      this.tenet = _reverse.default.limitRecord({
        limitTime: 31500
      }); // 回溯31秒前的操作
      // 尝试汇总上报的timeoutId

      this.tenetReportTimeoutId = null; // 当前错误标记的list

      this.errorMaskList = [];
    } // 组织config


    (0, _createClass2.default)(Base, [{
      key: "computeConfig",
      value: function computeConfig() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _conf = this.isOverwrite ? (0, _objectSpread2.default)({}, config) : _utils._.merge(commonConfig, config); // 检测配置项


        var uuid = _utils._.get(_conf, ['uuid'], '');

        if (uuid === '') {
          // 没有设置uuid时, 自动设置一个
          uuid = (0, _utils.getDeviceId)();
          _conf['uuid'] = uuid;
        }

        var ucid = _utils._.get(_conf, ['ucid'], '');

        if (ucid === '') {
          this.debugLogger('警告: 未设置ucid(用户唯一标识), 无法统计新增用户数');
        }

        var checkErrorNeedReportFunc = _utils._.get(_conf, ['record', 'js_error_report_config', 'checkErrorNeedReport']);

        if (_utils._.isFunction(checkErrorNeedReportFunc) === false) {
          // 如果新配置key中取不到回调函数不对, 则尝试一下旧配置
          checkErrorNeedReportFunc = _utils._.get(_conf, ['record', 'js_error_report_config', 'checkErrrorNeedReport']);
        } //  还不对就没办法了


        if (_utils._.isFunction(checkErrorNeedReportFunc) === false) {
          this.debugLogger('警告: config.record.js_error_report_config.checkErrorNeedReport 不是可执行函数, 将导致错误打点数据异常');
        }

        var getPageTypeFunc = _utils._.get(_conf, ['getPageType']);

        if (_utils._.isFunction(getPageTypeFunc) === false) {
          this.debugLogger('警告: config.getPageType 不是可执行函数, 将导致打点数据异常!');
        }

        global.__dt_conf = _conf;

        var isTest = _utils._.get(_conf, ['is_test'], _utils._.get(_constant.DEFAULT_CONFIG, ['is_test'])) || _utils._.get(_conf, ['test'], false); // 兼容旧配置项


        if (isTest) {
          _conf.test = _constant.TEST_FLAG;
          this.debugLogger('配置更新完毕');
          this.debugLogger('当前为测试模式');
          this.debugLogger('Tip: 测试模式下打点数据仅供浏览, 不会展示在系统中');
          this.debugLogger('更新后配置为:', _conf);
        }

        return _conf;
      } // 各种监控初始化

    }, {
      key: "init",
      value: function init() {
        var _context, _context7, _context8;

        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constant.DEFAULT_CONFIG;
        var isOverwrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        // 是否为覆盖模式
        this.isOverwrite = isOverwrite;
        this.config = commonConfig = this.computeConfig(config);
        this.isTest = !!_utils._.get(commonConfig, 'test', false);
        this.spa = !!_utils._.get(commonConfig, ['record', 'spa'], false); // 检查是否监控性能指标

        this.needRecordPerformance = _utils._.get(commonConfig, ['record', 'performance'], _utils._.get(_constant.DEFAULT_CONFIG, ['record', 'performance'])) || _utils._.get(commonConfig, ['performance'], false); // 兼容旧配置项
        // 检查是否监控JS错误

        this.needRecordJsError = _utils._.get(commonConfig, ['record', 'js_error'], _utils._.get(_constant.DEFAULT_CONFIG, ['record', 'js_error'])) || _utils._.get(commonConfig, ['jserror'], false); // 检查是否监控用户在线时长

        this.needRecordTimeOnPage = _utils._.get(commonConfig, ['record', 'time_on_page'], _utils._.get(_constant.DEFAULT_CONFIG, ['record', 'time_on_page'])) || _utils._.get(commonConfig, ['online'], false); // 检查是否监控API错误

        this.needRecordInterface = _utils._.get(commonConfig, ['record', 'api_report_config', 'enable'], _utils._.get(_constant.DEFAULT_CONFIG, ['record', 'api_report_config', 'enable'], true)); // 检查是否记录用户操作

        this.needRecordOperation = _utils._.get(commonConfig, ['record', 'record_operation'], _utils._.get(_constant.DEFAULT_CONFIG, ['record', 'record_operation'], false)); // let defaultSize = _.get(DEFAULT_CONFIG, ['record', 'behavior_queue_size'])
        // let configSize = _.get(this.config, ['record', 'behavior_queue_size'], defaultSize)
        // let behaviorQueueSize = parseInt(Math.min(configSize, 30)) || defaultSize
        // behaviorQueueSize = behaviorQueueSize <= 0 ? defaultSize : behaviorQueueSize
        // this.behaviorQueue = new BehaviorQueue(behaviorQueueSize)

        var me = this; // pv统计

        (0, _bind.default)(_flow.default).call(_flow.default, me)(); // 用户在线时长统计

        (0, _bind.default)(_context = _timeonpage.default.init).call(_context, me)(me.product); // 接口请求统计

        !me.needRecordPerformance && (0, _bind.default)(_apiTracker.default).call(_apiTracker.default, me)(me.interface); // js错误统计

        me.needRecordJsError && _jsTracker.default.init({
          concat: false,
          report: function () {
            var _report = (0, _asyncToGenerator2.default)(
            /*#__PURE__*/
            _regenerator.default.mark(function _callee() {
              var errorLogList,
                  _iteratorNormalCompletion,
                  _didIteratorError,
                  _iteratorError,
                  _iterator,
                  _step,
                  _context3,
                  _context4,
                  errorLog,
                  type,
                  desc,
                  stack,
                  strErrorType,
                  isErrorTypeNeedRecord,
                  _context2,
                  isNeedReport,
                  appendInfo,
                  _arr,
                  _i,
                  key,
                  ctn,
                  _context5,
                  errorName,
                  _location,
                  _args = arguments;

              return _regenerator.default.wrap(function _callee$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      errorLogList = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];

                      if (!(me.needRecordJsError === false)) {
                        _context6.next = 4;
                        break;
                      }

                      me.debugLogger("config.record.js_error\u4E3Afalse, \u8DF3\u8FC7\u9875\u9762\u62A5\u9519\u6253\u70B9, \u9875\u9762\u62A5\u9519\u5185\u5BB9\u4E3A =>", errorLogList);
                      return _context6.abrupt("return");

                    case 4:
                      _iteratorNormalCompletion = true;
                      _didIteratorError = false;
                      _iteratorError = undefined;
                      _context6.prev = 7;
                      _iterator = (0, _getIterator2.default)(errorLogList);

                    case 9:
                      if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _context6.next = 33;
                        break;
                      }

                      errorLog = _step.value;
                      type = errorLog.type, desc = errorLog.desc, stack = errorLog.stack; // 检测该errorType是否需要记录

                      strErrorType = _utils._.get(_constant.JS_TRACKER_ERROR_CONSTANT_MAP, type, '');
                      isErrorTypeNeedRecord = _utils._.get(commonConfig, ['record', 'js_error_report_config', strErrorType], _utils._.get(_constant.DEFAULT_CONFIG, ['record', 'js_error_report_config', strErrorType]));

                      if (!(isErrorTypeNeedRecord === false)) {
                        _context6.next = 17;
                        break;
                      }

                      // 主动配置了忽略该错误, 自动返回
                      me.debugLogger((0, _concat.default)(_context2 = "config.record.js_error_report_config.".concat(strErrorType, "\u503C\u4E3Afalse, \u8DF3\u8FC7\u7C7B\u522B\u4E3A")).call(_context2, strErrorType, "\u7684\u9875\u9762\u62A5\u9519\u6253\u70B9, \u9519\u8BEF\u4FE1\u606F=>"), errorLog);
                      return _context6.abrupt("continue", 30);

                    case 17:
                      _context6.next = 19;
                      return (0, _utils.customerErrorCheck)(commonConfig, (0, _bind.default)(_context3 = me.debugLogger).call(_context3, me), errorLog);

                    case 19:
                      isNeedReport = _context6.sent;
                      appendInfo = {
                        desc: desc,
                        stack: stack
                      };
                      _arr = (0, _keys.default)(_constant.ALLOWED_KEYS);

                      for (_i = 0; _i < _arr.length; _i++) {
                        key = _arr[_i];
                        ctn = _utils._.get(isNeedReport, [key], false);

                        if (ctn) {
                          ctn = (0, _slice.default)(_context5 = ctn + '').call(_context5, 0, _constant.ALLOWED_KEYS[key]);
                          appendInfo[key] = ctn;
                        }
                      }

                      if (!(!!isNeedReport === false)) {
                        _context6.next = 26;
                        break;
                      }

                      me.debugLogger("config.record.js_error_report_config.checkErrorNeedReport\u8FD4\u56DE\u503C\u4E3Afalse, \u8DF3\u8FC7\u6B64\u7C7B\u9519\u8BEF, \u9875\u9762\u62A5\u9519\u4FE1\u606F\u4E3A=>", {
                        desc: desc,
                        stack: stack
                      });
                      return _context6.abrupt("continue", 30);

                    case 26:
                      errorName = '页面报错_' + _constant.JS_TRACKER_ERROR_DISPLAY_MAP[type];
                      _location = window.location;
                      me.debugLogger('[自动]捕捉到页面错误, 发送打点数据, 上报内容 => ', (0, _objectSpread2.default)({
                        error_no: errorName,
                        url: (0, _concat.default)(_context4 = "".concat(_location.host)).call(_context4, _location.pathname)
                      }, appendInfo));
                      me.log('error', 7, {
                        error_no: errorName,
                        url: _location.href
                      }, appendInfo);

                    case 30:
                      _iteratorNormalCompletion = true;
                      _context6.next = 9;
                      break;

                    case 33:
                      _context6.next = 39;
                      break;

                    case 35:
                      _context6.prev = 35;
                      _context6.t0 = _context6["catch"](7);
                      _didIteratorError = true;
                      _iteratorError = _context6.t0;

                    case 39:
                      _context6.prev = 39;
                      _context6.prev = 40;

                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }

                    case 42:
                      _context6.prev = 42;

                      if (!_didIteratorError) {
                        _context6.next = 45;
                        break;
                      }

                      throw _iteratorError;

                    case 45:
                      return _context6.finish(42);

                    case 46:
                      return _context6.finish(39);

                    case 47:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee, this, [[7, 35, 39, 47], [40,, 42, 46]]);
            }));

            return function report() {
              return _report.apply(this, arguments);
            };
          }()
        }); // 页面性能统计

        (0, _bind.default)(_context7 = _performance.default.init).call(_context7, me)(me.log); // promise错误统计

        (0, _bind.default)(_context8 = _promise.default.init).call(_context8, me)(me.notify);
      } // 发送埋点请求

    }, {
      key: "send",
      value: function send() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var location = window.location;
        var pageType = location.href;

        var getPageTypeFunc = _utils._.get(commonConfig, ['getPageType'], _utils._.get(_constant.DEFAULT_CONFIG, ['getPageType']));

        try {
          pageType = '' + getPageTypeFunc(location);
        } catch (e) {
          var _context9;

          this.debugLogger("config.getPageType\u6267\u884C\u65F6\u53D1\u751F\u5F02\u5E38, \u8BF7\u6CE8\u610F, \u9519\u8BEF\u4FE1\u606F=>", {
            e: e,
            location: location
          });
          pageType = (0, _concat.default)(_context9 = "".concat(location.host)).call(_context9, location.pathname);
        }

        info = (0, _assign.default)({
          type: '',
          common: (0, _objectSpread2.default)({}, commonConfig, {
            timestamp: (0, _now.default)(),
            runtime_version: commonConfig.version,
            sdk_version: _package.default.version,
            page_type: pageType,
            dsp_w: _utils._.get(global, ['screen', 'width'], 0),
            dsp_h: _utils._.get(global, ['screen', 'height'], 0),
            win_iw: _utils._.get(global, ['innerWidth'], 0)
          })
        }, info); // 图片打点
        // const img = new window.Image()
        // img.src = `${TARGET}?d=${encodeURIComponent(JSON.stringify(info))}`

        this.upload(info);
      }
      /**
       * 打点数据上报方法
       * @param {类型} type
       * @param {code码} code
       * @param {消费数据} detail
       * @param {展示数据} extra
       */

    }, {
      key: "log",
      value: function log() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var code = arguments.length > 1 ? arguments[1] : undefined;
        var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var errorMsg = (0, _utils.validLog)(commonConfig, type, code, detail, extra);

        if (errorMsg) {
          (0, _utils.clog)(errorMsg);
          return errorMsg;
        }

        if (type === _constant.LOG_TYPE_ERROR && this.needRecordOperation && !this.isTest) {
          var _context10;

          // this.isTest && clog('你已打开【用户操作记录】功能，该功能可能涉及用户隐私相关问题，上线前请一定确认是否需要打开该功能！！！')
          var stack = extra.stack;
          var error_name = detail.error_name;
          this.tenet.addCustomEvent((0, _concat.default)(_context10 = "".concat(error_name, ":")).call(_context10, stack), {
            type: type,
            code: code,
            detail: detail,
            extra: extra
          });
          var errorMark = this.getErrorSelectMark(stack); // 这里生成新的自定义事件

          detail.user_actions = errorMark;
          this.tryToGetReportOrder(errorMark);
        }

        var logInfo = {
          type: type,
          code: code,
          extra: extra,
          detail: (0, _utils.detailAdapter)(code, detail)
        }; // if (type === LOG_TYPE_ERROR && this.behaviorQueue.size) {
        //   let zipedActions = gzip(JSON.stringify(this.behaviorQueue.data))
        //   logInfo.detail.user_actions = zipedActions
        //   this.behaviorQueue.clearQueue()
        // }

        this.send(logInfo);
      } // 发送错误类型埋点

    }, {
      key: "error",
      value: function error(code, detail, extra) {
        // 在这里计算出来错误的片段id
        // 尝试去验证这个片段是否需要去上报
        return this.log('error', code, detail, extra);
      } // 发送产品类型埋点

    }, {
      key: "product",
      value: function product(code, detail, extra) {
        return this.log('product', code, detail, extra);
      } // 暂未使用

    }, {
      key: "info",
      value: function info(code, detail, extra) {
        return this.log('info', code, detail, extra);
      } // 发送接口请求类型埋点

    }, {
      key: "interface",
      value: function _interface(code, detail, extra) {
        return this.log('api', code, detail, extra);
      } // 测试环境打log

    }, {
      key: "debugLogger",
      value: function debugLogger() {
        var _console;

        // 只有在测试时才打印log
        if (this.isTest) (_console = console).log.apply(_console, arguments);
      }
    }, {
      key: "getErrorSelectMark",
      value: function getErrorSelectMark(stack) {
        var pid = _utils._.get(commonConfig, ['pid'], '');

        return (0, _blueimpMd.default)((0, _stringify.default)({
          stack: stack,
          pid: pid
        }));
      } // 这里去发送请求决定是否要去拿到到tenet的数据并上报

    }, {
      key: "tryToGetReportOrder",
      value: function tryToGetReportOrder(errorMark) {
        var _this = this;

        this.errorMaskList.push(errorMark);
        clearTimeout(this.tenetReportTimeoutId); // 尝试在timeout结束后汇总上报片段

        this.tenetReportTimeoutId = (0, _setTimeout2.default)(function () {
          return _this.getTenetData();
        }, 5000);
      }
    }, {
      key: "getTenetData",
      value: function getTenetData() {
        var _this2 = this;

        var errorMaskList = this.errorMaskList;
        this.errorMaskList = [];
        this.tenet.getEvents().then(function (events) {
          return _this2.getReportOrder(events, errorMaskList);
        }).catch(function (error) {
          return error;
        });
      } // 获取是否要上报的命令

    }, {
      key: "getReportOrder",
      value: function getReportOrder(events, errorMaskList) {
        var _this3 = this;

        // 先把片段拉出来看看有没有问题
        var errorMarks = errorMaskList.join(',');
        var url = "//time-sdk.lianjia.com/time/record/keys?marks=".concat(errorMarks);
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.send();

        xhr.onreadystatechange = function () {
          if (xhr.readyState !== 4) {
            return;
          } // 判断是否成功的发送了请求


          if (xhr.status === 200) {
            // 重新把失败的装进去
            try {
              var result = JSON.parse(xhr.responseText);

              if (result) {
                var hit = result.hit;

                if (hit) {
                  _this3.tenetReport(events, errorMaskList.join(' '));
                }
              }
            } catch (e) {}
          }
        };
      } // 准备上报数据

    }, {
      key: "tenetReport",
      value: function tenetReport(events, errorMaskList) {
        events.unshift({
          type: 'info',
          eid: errorMaskList
        });
        (0, _report2.default)(events);
      }
    }]);
    return Base;
  }();

  var Logger =
  /*#__PURE__*/
  function (_Base) {
    (0, _inherits2.default)(Logger, _Base);

    function Logger() {
      (0, _classCallCheck2.default)(this, Logger);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Logger).apply(this, arguments));
    }

    (0, _createClass2.default)(Logger, [{
      key: "set",
      // constructor () {
      //   super()
      // }
      value: function set() {
        var _get2, _context11;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_get2 = (0, _get3.default)((0, _getPrototypeOf2.default)(Logger.prototype), "init", this)).call.apply(_get2, (0, _concat.default)(_context11 = [this]).call(_context11, args));
      }
      /**
       * 用户行为监控
       * @param {String} code [必填]用户行为标识符, 用于唯一判定用户行为类型, 最多50字符( menu/click/button_1/button_2/etc)
       * @param {String} name [必填]用户行为名称, 和code对应, 用于展示, 最多50字符
       * @param {String} url  [可选]用户点击页面url, 可以作为辅助信息, 最多200字符
       */

    }, {
      key: "behavior",
      value: function behavior() {
        var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        this.debugLogger('发送用户点击行为埋点, 上报内容 => ', {
          code: code,
          name: name,
          url: url
        });
        this.product(10002, {
          code: code,
          name: name,
          url: url
        });
      }
      /**
       * 用于用户主动上报错误
       * @param {string} [errorName='']
       * @param {string} [url='']
       * @param {*} [extraInfo={}]
       * @returns
       * @memberof Logger
       */

    }, {
      key: "notify",
      value: function notify() {
        var errorName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var extraInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        // 规范请求参数
        var detail = {};
        var extra = {};

        if (!errorName) {
          console.log('dt.notify 的 errorName 不能为空');
          return;
        }

        detail['error_name'] = '' + errorName;
        detail['url'] = '' + url; // 最大不能超过200字

        if (detail['error_name'].length > 200) {
          var _context12;

          detail['error_name'] = (0, _slice.default)(_context12 = detail['error_name']).call(_context12, 0, 200);
          this.debugLogger('error_name长度不能超过200字符, 自动截断. 截断后为=>', detail['error_name']);
        }

        if (detail['url'].length > 200) {
          var _context13;

          detail['url'] = (0, _slice.default)(_context13 = detail['url']).call(_context13, 0, 200);
          this.debugLogger('url长度不能超过200字符, 自动截断. 截断后为=>', detail['error_name']);
        }

        var _arr2 = ['http_code', 'during_ms', 'request_size_b', 'response_size_b'];

        for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
          var intKey = _arr2[_i2];

          if (_utils._.has(extraInfo, [intKey])) {
            var code = (0, _parseInt2.default)(extraInfo[intKey]);

            if (isNaN(code) === false) {
              detail[intKey] = code;
            } else {
              detail[intKey] = 0; // 赋上默认值
            }
          }
        } // 将rawDetail中的其余key存到extra中


        var _arr3 = (0, _keys.default)(extraInfo);

        for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
          var extraKey = _arr3[_i3];
          var protectKeyMap = {
            'error_no': true,
            'error_name': true,
            'url': true,
            'http_code': true,
            'during_ms': true,
            'request_size_b': true,
            'response_size_b': true
          };

          if (protectKeyMap[extraKey] !== true) {
            extra[extraKey] = extraInfo[extraKey];
          }
        }

        this.debugLogger('发送自定义错误数据, 上报内容 => ', {
          detail: detail,
          extra: extra
        });
        return this.error(8, detail, extra);
      }
      /**
       * 提供通用的埋点方法
       * @param {String} name
       * @param {*} args
       */

    }, {
      key: "logger",
      value: function logger() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!name) return this.debugLogger('警告: 未设置【name】(打点事件名)属性, 无法统计该打点数据！');
        if (typeof name !== 'string') return this.debugLogger('【name属性】(打点事件名)仅支持字符串类型！');
        this.debugLogger("\u53D1\u9001\u3010event\u3011\u7C7B\u578B\u57CB\u70B9\uFF0C\u4E8B\u4EF6\u540D\uFF1A\u3010".concat(name, "\u3011. \u4E0A\u62A5\u5185\u5BB9 => "), args);
        this.send({
          type: 'event',
          name: name,
          props: (0, _objectSpread2.default)({}, args),
          extra: extra
        });
      }
      /**
       * 白屏检测功能API
       * @param {*} target     需要监测DOM变动的节点
       * @param {*} notify     【必填】错误上报的配置
       * @param {*} config     【可选】监测配置
       * @param {*} cb         【可选】需要执行的业务回调
       * @returns {Instance of MutationObserver} 返回MutationObserver的实例，业务可根据需要调用disconnect方法来关闭监测
       */

    }, {
      key: "detect",
      value: function detect() {
        var _context14,
            _this4 = this;

        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;
        var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;

        if (_utils._.isFunction(config)) {
          cb = config;
          config = {};
        }

        var _notify$errorName = notify.errorName,
            errorName = _notify$errorName === void 0 ? '加载页面异常_WhiteScreen' : _notify$errorName,
            _notify$url = notify.url,
            url = _notify$url === void 0 ? (0, _concat.default)(_context14 = "".concat(location.host)).call(_context14, location.pathname) : _notify$url,
            _notify$extraInfo = notify.extraInfo,
            extraInfo = _notify$extraInfo === void 0 ? {} : _notify$extraInfo;
        var CONF = {
          subtree: true,
          childList: true,
          attributes: false,
          characterData: false,
          timeout: 5 * 1000
        };
        config = _utils._.merge(CONF, config);
        this.debugLogger("\u767D\u5C4F\u68C0\u6D4B\u914D\u7F6E: ====>", config, cb);

        if (!(0, _utils.isDom)(target)) {
          (0, _utils.clog)('param [target] must be a instance of HTMLElement');
          return;
        }

        var _config = config,
            _config$timeout = _config.timeout,
            timeout = _config$timeout === void 0 ? 5 * 1000 : _config$timeout,
            _config$childList = _config.childList,
            childList = _config$childList === void 0 ? true : _config$childList,
            _config$attributes = _config.attributes,
            attributes = _config$attributes === void 0 ? false : _config$attributes,
            _config$characterData = _config.characterData,
            characterData = _config$characterData === void 0 ? false : _config$characterData;

        if (!(attributes || childList || characterData)) {
          (0, _utils.clog)("attributes childList characterData\u914D\u7F6E\u4E0D\u5408\u6CD5, \u8DF3\u8FC7\u767D\u5C4F\u68C0\u6D4B");
          return;
        }

        var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
        if (!MutationObserver) return (0, _utils.clog)('您的浏览器不支持 MutationObserver API, 跳过白屏检测'); // 超过设置的超时时间后，执行该逻辑，上报白屏错误

        var timer = (0, _setTimeout2.default)(function () {
          _this4.notify(errorName, url, extraInfo);

          _utils._.isFunction(cb) && cb(mo);
        }, timeout);
        var mo = void 0;

        var callback = function callback(records) {
          clearTimeout(timer);
          _utils._.isFunction(cb) && cb(mo, records);
        };

        mo = new MutationObserver(callback);
        mo.observe(target, config);
        return mo;
      }
    }]);
    return Logger;
  }(Base);

  var logger = new Logger(); // 重新挂载一下吧，要不然会导致低版本不兼容

  global.dt = logger;
  var Elog = (0, _bind.default)(_context15 = logger.error).call(_context15, logger);
  _exports.Elog = Elog;
  var Plog = (0, _bind.default)(_context16 = logger.product).call(_context16, logger);
  _exports.Plog = Plog;
  var Ilog = (0, _bind.default)(_context17 = logger.info).call(_context17, logger);
  _exports.Ilog = Ilog;
  var _default = logger;
  _exports.default = _default;
});